import { Model } from '../parents/model';

export class PaymentMethodModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  static ATTR_PRICE = 'price';

  static ATTR_TAXED_PRICE = 'taxed_price';

  static ATTR_HAS_COSTOMER_GROUPS = 'has_customer_groups';

  static ATTR_DESCRIPTION = 'description';

  static ATTR_PAYMENT_NOTE = 'payment_note';

  static ATTR_IMAGE_ID = 'image_id';

  static ATTR_TAX_GROUP_ID = 'tax_group_id';

  static ATTR_IS_ACTIVE = 'is_active';

  static ATTR_PAYMENT_SERVICE = 'payment_service';

  static ATTR_BANK_ACCOUNT = 'bank_account';

  static ATTR_POSITION = 'position';

  static ATTR_HAS_CUSTOMER_GROUPS = 'has_customer_groups';

  static EMBED_CUSTOMER_GROUP_IDS = 'customer_group_ids';

  get name() {
    return this.attributes[PaymentMethodModel.ATTR_NAME];
  }

  get price() {
    return this.attributes[PaymentMethodModel.ATTR_PRICE];
  }

  get taxedPrice() {
    return this.attributes[PaymentMethodModel.ATTR_TAXED_PRICE];
  }

  get description() {
    return this.attributes[PaymentMethodModel.ATTR_DESCRIPTION];
  }

  get paymentNote() {
    return this.attributes[PaymentMethodModel.ATTR_PAYMENT_NOTE];
  }

  get imageId() {
    return this.attributes[PaymentMethodModel.ATTR_IMAGE_ID];
  }

  get taxGroupId() {
    return this.attributes[PaymentMethodModel.ATTR_TAX_GROUP_ID];
  }

  get isActive() {
    return this.attributes[PaymentMethodModel.ATTR_IS_ACTIVE];
  }

  get paymentService() {
    return this.attributes[PaymentMethodModel.ATTR_PAYMENT_SERVICE];
  }

  get bankAccount() {
    return this.attributes[PaymentMethodModel.ATTR_BANK_ACCOUNT];
  }

  get position() {
    return this.attributes[PaymentMethodModel.ATTR_POSITION];
  }

  get hasCustomerGroups() {
    return this.attributes[PaymentMethodModel.ATTR_HAS_CUSTOMER_GROUPS];
  }

  get customerGroupIds() {
    return this.embeds[PaymentMethodModel.EMBED_CUSTOMER_GROUP_IDS];
  }
}
